module.exports = __webpack_public_path__ + "img/BannerNewMobile.08b6687a.png";